import './change-requests-controller';
import './change-requests-details-controller';